import AppWrapper from './AppWrapper'
import React, { useEffect } from 'react'
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { appUrls } from '../../utils/urls/appUrls'
import '../../assets/css/layoutStyles.css'
import '../../assets/css/certifcateStyles.css'
import { clearAll, clearResponseMsg, clearOnReload, logoutAppUser } from '../../config/redux/slice/appSlice'
import { onGetCurrencies, setActiveSidebar } from '../../config/redux/slice/appSlice';
import { getRequest } from '../../helpers/request';
import { appApi } from '../../utils/endpoints/appApi';
import { handleOnPageLoad, handleOverlayClick } from '../../helpers/sideBarToggle';
import { logoutUser } from '../../config/redux/slice/authSlice';
import { logoutBankUser } from '../../config/redux/slice/bankUserSlice';
import { logoutNotapUser } from '../../config/redux/slice/notapUserSlice';
import { logoutTransfereeUser } from '../../config/redux/slice/transfereeUserSlice';

export default function GeneralWrapper({children, pageTitle}) {
    const dispatch = useDispatch()
  const navigate = useNavigate()
  const {
        userErrorMsg,
        userSuccessMsg,
        certificateManagement:{certificatesData, newData, showCertificateForm}
    } = useSelector((state) => state.app)

  const {
        token,
        userData: {isProfileComplete, user_role}
    } = useSelector((state) => state.authData)

    useEffect(()=>{
      dispatch(clearOnReload())
      dispatch(clearAll())
    }, [])

    const showToastMessage = (msg, isError) => {
      if(isError){
        toast.error(msg, {
            position: toast.POSITION.TOP_RIGHT
        });
      } else{
        toast.success(msg, {
            position: toast.POSITION.TOP_RIGHT
        });
      }
        
    };

    useEffect(()=>{
    if(userSuccessMsg){
        let msg;
        if(Array.isArray(userSuccessMsg)){
          msg = userSuccessMsg[0].toLowerCase().charAt(0).toUpperCase() + userSuccessMsg[0].slice(1)
        } else{
          msg = userSuccessMsg.toLowerCase().charAt(0).toUpperCase() + userSuccessMsg.slice(1)
        }

        dispatch(clearResponseMsg())

        showToastMessage(msg, false)
        
    }

    if(userErrorMsg){
      let err
      if(Array.isArray(userErrorMsg)){
        err = userErrorMsg[0].toLowerCase().charAt(0).toUpperCase()+userErrorMsg[0].slice(1)
      }
      else{
        err = userErrorMsg.toLowerCase().charAt(0).toUpperCase()+userErrorMsg.slice(1)
      }
      dispatch(clearResponseMsg())
        if(err == 'Invalid token'){
          dispatch(logoutUser())
          dispatch(logoutBankUser())
          dispatch(logoutAppUser())
          dispatch(logoutNotapUser())
          dispatch(logoutTransfereeUser())
          err = null
        }else{
          showToastMessage(err, true)
        }

        // showToastMessage(err, true)
    }
    }, [userSuccessMsg, userErrorMsg])

    // useEffect(()=>{
    //     if(token===''){
    //         navigate(appUrls.login)
    //     }
    // }, [token])


  return (
    <AppWrapper pageTitle={pageTitle}>
      <>
      {children}
      </>
    </AppWrapper>
  )
}
